import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-sparkling-2-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">萌妖图鉴</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300/80">
              韩国妖精漫画角色图鉴站，专注整理女主颜值与人设、萌娘属性、CP组合与人物关系，让你一键点进对应作品页，查清每位女主的魅力所在。
            </p>
            <div className="mt-4 flex items-center gap-3">
              <a href="#" rel="nofollow noopener" aria-label="微博" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-weibo-line" aria-hidden="true"></i>
              </a>
              <a href="#" rel="nofollow noopener" aria-label="哔哩哔哩" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-bilibili-line" aria-hidden="true"></i>
              </a>
              <a href="#" rel="nofollow noopener" aria-label="贴吧" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/10 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-question-answer-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-background-100">图鉴导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/encyclopedia" className="text-background-300 hover:text-background-50 transition-colors">角色图鉴</Link></li>
              <li><Link to="/works" className="text-background-300 hover:text-background-50 transition-colors">作品大全</Link></li>
              <li><Link to="/about" className="text-background-300 hover:text-background-50 transition-colors">关于我们</Link></li>
              <li><Link to="/faq" className="text-background-300 hover:text-background-50 transition-colors">常见问题</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-background-100">热门标签</h4>
            <div className="mt-4 flex flex-wrap gap-2">
              {["傲娇", "软萌", "御姐", "九尾狐", "猫妖", "凤凰", "冰雪", "元气"].map((tag) => (
                <Link
                  key={tag}
                  to={`/encyclopedia?tag=${encodeURIComponent(tag)}`}
                  className="rounded-full bg-background-50/10 px-3 py-1 text-xs text-background-200 hover:bg-accent-500 hover:text-background-50 transition-colors"
                >
                  {tag}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wide text-background-100">联系我们</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-background-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-background-400" aria-hidden="true"></i>
                <span>contact@yaojing-tujian.example.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-message-3-line text-background-400" aria-hidden="true"></i>
                <span>投稿 / 纠错 / 合作交流</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-background-400" aria-hidden="true"></i>
                <span>内容每周持续更新</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-background-50/10 pt-6 sm:flex-row">
          <p className="text-xs text-background-400">
            © {new Date().getFullYear()} 萌妖图鉴 · 韩国妖精漫画角色资料整理与爱好者交流平台
          </p>
          <p className="text-xs text-background-400">本站内容仅供爱好者交流与科普，版权归原作者所有</p>
        </div>
      </div>
    </footer>
  );
}